import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const embedConverter = {
  toPm: {
    types: [Node_Type.EMBED],
    // @ts-expect-error next node type
    convert: (node) => ({
      type: Node_Type.EMBED,
      attrs: {
        ...node.embedData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.EMBED],
    // @ts-expect-error next node type
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.EMBED,
        id,
        nodes: [],
        embedData: {
          ...data
        }
      };
    }
  }
};
export {
  embedConverter
};
//# sourceMappingURL=embed-converter.js.map
